import React from 'react';
import moment from 'moment';
import { useBranch } from 'baobab-react/hooks';
import { FiEdit, FiInfo /*FiTrash2, FiList,*/ } from 'react-icons/fi';

const LicenceManagement = (props) => {
	const { licences } = useBranch({
		licences: ['licences'],
	});

	return (
		<div className="container">
			<div className="d-flex align-items-center justify-content-between py-4 mb-3 border-bottom">
				<div>
					<h2 className="mb-1">Licence management</h2>
					<p className="text-muted mb-0">Manage on premise licences here</p>
				</div>
				<button
					onClick={() => {
						props.history.push('/licences/new');
					}}
					type="button"
					className="btn btn-primary"
				>
					CREATE LICENCE
				</button>
			</div>

			<table className="table table-hover align-middle">
				<thead className="table-dark">
					<tr>
						<th scope="col">Company / Support</th>
						<th scope="col">Package</th>
						<th scope="col" className="text-center">Activation / Refresh</th>
						<th scope="col" className="text-center">Trial date</th>
						<th scope="col" className="text-center">Expiration date</th>
						<th scope="col" className="text-center">Actions</th>
					</tr>
				</thead>
				<tbody>
					{licences.map((lic) => {
						return (
							<tr key={lic.uuid}>
								<td>
									<strong>{lic.company}</strong>
									<br />
									<small className="text-muted">{lic.administrativeEmail}</small>
								</td>
								<td>{lic.package}</td>
								<td className="text-center">
									<small>
										{moment(lic.activationDate).format('lll')}
										<br />
										{moment(lic.lastLicenceRefresh).format('lll')}
									</small>
								</td>
								<td className="text-center">
									<small>{moment(lic.trialToDate).format('lll')}</small>
								</td>
								<td className="text-center">
									<small>{moment(lic.expirationDate).format('lll')}</small>
								</td>
								<td className="text-center">
									<div className="btn-group" role="group">
										<button
											onClick={() => {
												props.history.push(`/licences/edit/${lic.uuid}`);
											}}
											className="btn btn-sm btn-outline-primary"
											title="Edit"
										>
											<FiEdit />
										</button>
										<button
											onClick={() => {
												props.history.push(`/licences/view/${lic.uuid}`);
											}}
											className="btn btn-sm btn-outline-info"
											title="View"
										>
											<FiInfo />
										</button>
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default LicenceManagement;